import { buildMediaAssetIdParam } from '@/helpers/buildMediaAssetIdParam';

export const buildMediaAssetViewParams = ({
  storeeelName,
  groupId,
  mediaId,
  campaignId,
  mediaAssetType,
}) => {
  const params = {
    storeeel_name: storeeelName,
    group_id: groupId,
    campaign_id: campaignId,
  };

  Object.assign(params, buildMediaAssetIdParam(mediaId, mediaAssetType));

  return params;
};
